import * as api from '@owl-nest/api-client/latest'
import { t } from '@owl-nest/localize'
import { glyphs } from '@ulule/owl-kit-components/next'

export type PaymentMethod = {
  readonly description: string
  readonly id: string
  readonly name: string
  readonly action: string
  readonly icon: keyof (typeof glyphs)['paymentMethods']
}

export function getMethodName(paymentMethod: api.PaymentMethod): string {
  switch (paymentMethod) {
    case api.PaymentMethod.BANKWIRE:
      return t('Bank transfer')
    case api.PaymentMethod.CARD:
    case api.PaymentMethod.CREDITCARD:
      return t('Credit card')
    case api.PaymentMethod.CHECK:
      return t('Check')
    case api.PaymentMethod.DIRECTDEBIT:
      return t('Direct debit')
    case api.PaymentMethod.IDEAL:
      return 'iDEAL'
    case api.PaymentMethod.MAESTRO:
      return 'Maestro'
    case api.PaymentMethod.PAYLIB:
      return 'Paylib'
    case api.PaymentMethod.PAYPAL:
      return 'PayPal'
    case api.PaymentMethod.SAVING:
      return t('Saving')
    default:
      return ''
  }
}

export function getPaymentMethods(projectIsDonationBased?: boolean): Record<string, PaymentMethod> {
  return {
    bankwire: {
      description: t(
        'To pay by bank transfer, you must send a transfer directly from your bank account. Bank details and a unique reference will be provided to you in the next step. Upon receipt of the transfer, you will receive a confirmation email.',
      ),
      id: 'bankwire',
      name: t('Bank transfer'),
      action: t('Bankwire payment'),
      icon: 'Bankwire',
    },
    check: {
      description: t(
        'The project creator undertakes to cash-in your check only if the project funding goal is reached, or to cash it in immediately but to reimburse you if the project funding goal is not reached at the end of the fundraising period.',
      ),
      id: 'check',
      name: t('Check'),
      action: t('Check payment'),
      icon: 'NeutralCard',
    },
    card: {
      description: projectIsDonationBased
        ? t('The simplest and fastest solution. Secure payment operated by Ulule.')
        : t(
            'The simplest and fastest solution. Secure payment operated by Ulule. You are charged immediately, but you will be fully refunded (without any fees) if the project misses its target.',
          ),
      id: 'card',
      name: t('Card payment (credit, debit, maestro)'),
      action: t('Card payment'),
      icon: 'CreditCard',
    },
    directdebit: {
      description: t(
        'Pay with online banking -two systems available: SOFORT and GIROPAY. Payment with existing online banking account. Available for users whose bank accept one of these payment methods (generally the case in Germany and Austria, and sometimes in Switzerland and Belgium). Please prepare your PIN / TAN.',
      ),
      id: 'directdebit',
      name: t('Direct debit'),
      action: t('Direct debit payment'),
      icon: 'NeutralCard',
    },
    ideal: {
      description: t(
        'You are charged immediately but you will be fully refunded (without any fees), if the project misses its target.',
      ),
      id: 'ideal',
      name: 'iDEAL',
      action: t('iDEAL payment'),
      icon: 'IDeal',
    },
    paylib: {
      description: t(
        'Only if you have a Paylib account, you are charged immediately but you will be fully refunded (without any fees), if the project misses its target.',
      ),
      id: 'paylib',
      name: 'Paylib',
      action: t('Paylib payment'),
      icon: 'Paylib',
    },
    paypal: {
      description: t('You will be charged only if the project owner meets their goal.'),
      id: 'paypal',
      name: 'PayPal',
      action: t('PayPal payment'),
      icon: 'Paypal',
    },
  }
}
